import genererMouvementOd from '@/services/compta/operationDiverse/genererMouvementOd';

export default function genererOperationDiverse() {
  return {
    reference: null,
    journal: null,
    exportOdComptabilite: false,
    mouvementOd: genererMouvementOd(),
    lignesOd: [],
  };
}
